import { cn } from "@/lib/utils";
import type { HTMLAttributes } from "react";

export function RoundButtonsContainer({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("button_icons_container ml-auto w-fit shrink-0", className)}
      {...props}
    />
  );
}
